export default __webpack_public_path__ + "static/media/my-customers.356b1cfa.png";